"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.TableWrapper=exports.StyledTable=void 0;const TableWrapper=exports.TableWrapper=_styledComponents.default.div`
  margin: 1rem auto;
`,StyledTable=exports.StyledTable=_styledComponents.default.table`
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  table-layout: fixed;
  width: 100%;

  thead tr {
    border-top: 1px solid #c8c7cc;
    border-bottom: 1px solid #c8c7cc;
  }

  thead th:first-child {
    padding: 0.5rem 0 0.25rem 1rem;
    text-align: left;
  }

  thead th:last-child {
    text-align: right;
    padding-right: 1.5rem;
  }

  th,
  td {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  td:first-child {
    padding: 0.375rem 0 0.375rem 1rem;
  }

  td:last-child {
    text-align: right;
    padding-right: 1.5rem;
  }

  .danger {
    color: red;
  }
`;